// @flow

import React from "react";
import styled from "styled-components";

import Checkbox from "material-ui/Checkbox";
import Visibility from "material-ui/svg-icons/action/visibility";
import VisibilityOff from "material-ui/svg-icons/action/visibility-off";

// Helpers
import spacingExtender, { spacingSizes } from "./spacingExtender";

const Input = styled.input`
  border-width: 1px;
  border-color: ${props => (props.borderColor ? props.borderColor : props.theme.textInput.borderColor)} !important;
  border-style: solid;
  border-radius: 5px;
  display: block;
  font-size: ${props => props.theme.textInput.fontSize};
  font-family: ${props => props.theme.textInput.fontFamily};
  font-weight: ${props => props.theme.textInput.fontWeight};
  padding: 12px;
  outline: none;
  width: 100%;
  ${spacingExtender};
`;

const TextArea = styled.textarea`
  resize: none;
  border-width: 1px;
  border-color: ${props => (props.borderColor ? props.borderColor : props.theme.textInput.borderColor)} !important;
  border-style: solid;
  border-radius: 5px;
  display: block;
  font-size: ${props => props.theme.textInput.fontSize};
  font-family: ${props => props.theme.textInput.fontFamily};
  font-weight: ${props => props.theme.textInput.fontWeight};
  padding: 12px;
  outline: none;
  width: 100%;
  min-height: 110px;
  ${spacingExtender};
`;

const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PasswordToggle = styled.div`
  align-items: center;
  bottom: ${({ marginB }) => spacingSizes[marginB]};
  cursor: pointer;
  display: flex;
  position: absolute;
  top: 0;
  right: 12px;
`;

class Password extends React.Component {
  state = {
    togglePassword: false
  };
  render() {
    const { marginB } = this.props;
    return (
      <PasswordWrapper>
        <PasswordToggle marginB={marginB}>
          <Checkbox
            disableTouchRipple
            defaultChecked={this.state.togglePassword}
            checkedIcon={<VisibilityOff />}
            uncheckedIcon={<Visibility />}
            onCheck={() =>
              this.setState({ togglePassword: !this.state.togglePassword })}
          />
        </PasswordToggle>
        <Input
          type={this.state.togglePassword ? "text" : "password"}
          {...this.props}
        />
      </PasswordWrapper>
    );
  }
}

const TextInput = (
  { type = "text", ...rest }: { type?: string, rest: Object } = {}
) => {
  return <Input type={type} {...rest} />;
};

const PasswordInput = ({ type: string, ...rest }) => {
  return <Password {...rest} />;
};

const TextAreaInput = props => {
  return <TextArea {...props} />;
};

export default TextInput;
export { TextInput, PasswordInput, TextAreaInput };



// WEBPACK FOOTER //
// ./src/common/textInput.js